import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import FadeInSection from "./FadeInSection";

const isHorizontal = window.innerWidth < 600;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  if (isHorizontal) {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography component="div">{children}</Typography>
          </Box>
        )}
      </div>
    );
  } else {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography component="div">{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  if (isHorizontal) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  } else {
    return {
      id: `vertical-tab-${index}`,
    };
  }
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "theme.palette.background.paper",
    display: "flex",
    height: 300,
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}));

const JobList = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const experienceItems = {
    Exyte: {
      jobTitle: "Software Engineer Intern @",
      duration: "AUG 2025 - MAR 2026",
      desc: [
        "Built React.js components for internal business applications used by 10,000+ employees across global operations.",
        "Designed and implemented scalable REST API backend services using Spring Boot and NoSQL databases, while containerizing applications with Docker, automating deployments through GitHub Actions CI/CD pipelines, and collaborating in Agile (Scrum) teams to deliver features efficiently.",
        
      ],
    },
     DataAnnotation: {
      jobTitle: "Freelance Software Engineer @",
      duration: "AUG 2023 - FEB 2026",
      desc: [
        "Developed and optimized multiple backend applications using Python and FastAPI, including AI-powered features and API integrations.",
        "Evaluated, tested, and improved AI-generated code by writing efficient solutions, debugging issues, and providing technical feedback for model improvement.",
        
      ],
    },
    PharmaPlan: {
      jobTitle: "Software Engineer Intern @",
      duration: "MAR 2024 - AUG 2025",
      desc: [
        "•	Built scalable backend services using Java and Spring Boot, supporting internal business logic and automation workflows across all applications, Worked with AWS cloud services to support and optimize cloud-based applications.",
        "Processed, analyzed, and transformed data using Python, Pandas, PostgreSQL, and JSON as part of ETL workflows, while optimizing internal automation pipelines and ensuring data accuracy and consistency across processes. "

      ],
    }
  

  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={`${classes.root} joblist-root`}>
      <Tabs
        orientation={!isHorizontal ? "vertical" : "horizontal"}
        variant={isHorizontal ? "fullWidth" : "scrollable"}
        value={value}
        onChange={handleChange}
        className={`${classes.tabs} joblist-tabs`}
      >
        {Object.keys(experienceItems).map((key, i) => (
          <Tab key={key} label={isHorizontal ? `0${i}.` : key} {...a11yProps(i)} />
        ))}
      </Tabs>
      {Object.keys(experienceItems).map((key, i) => (
        <TabPanel key={key} value={value} index={i}>
          <span className="joblist-job-title">
            {experienceItems[key]["jobTitle"] + " "}
          </span>
          <span className="joblist-job-company">{key}</span>
          <div className="joblist-duration">
            {experienceItems[key]["duration"]}
          </div>
          <ul className="job-description">
            {experienceItems[key]["desc"].map(function (descItem, i) {
              return (
                <FadeInSection key={`${key}-${i}`} delay={`${i + 1}00ms`}>
                  <li>{descItem}</li>
                </FadeInSection>
              );
            })}
          </ul>
        </TabPanel>
      ))}
    </div>
  );
};

export default JobList;
